import { useEffect, useState, useCallback } from 'react'
import { FirebaseApp } from 'firebase/app'
import styled from 'styled-components'
import { useNavigate } from 'react-location'
import { Spin, PageHeader, message, Button } from 'antd'
import { FirebaseSessionKey, backgroundImage } from '../constants'

import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore/lite'

import NewTest from '../icnftests'
import ICNFResults from './result'
import NewTestLupa from '../lupatests'
import LUPAResults from './resultLupa'
import Profile from '../profile'
import Doc from '../docviewer'

import Navbar from '../navbar'

type Props = { firebaseApp: FirebaseApp }
const Dashboard = ({ firebaseApp }: Props) => {
  const navigate = useNavigate()
  const userLogged = window.sessionStorage.getItem(FirebaseSessionKey)

  const [activeMenu, setActiveMenu] = useState<string | undefined>(undefined)
  const [userHasBilling, setUserHasBilling] = useState<boolean | undefined>(
    undefined
  )

  const currentUser = JSON.parse(
    window.sessionStorage.getItem(FirebaseSessionKey) as string
  )

  const paymentsCall = useCallback(async () => {
    const user = currentUser
    const db = getFirestore(firebaseApp)
    const citiesCol = collection(db, 'billing')
    const q = query(citiesCol, where('user_uid', '==', user.uid))
    const querySnapshot = await getDocs(q)
    const eventList = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }))
    return eventList[0]
  }, [currentUser, firebaseApp])

  const makePaymentsGet = useCallback(() => {
    paymentsCall().then((data: any) => {
      setUserHasBilling(data || false)
    })
  }, [paymentsCall])

  useEffect(() => {
    if (!userLogged) {
      navigate({ to: '/', replace: true })
    }
  }, [navigate, userLogged])

  useEffect(() => {
    const user = currentUser
    if (user && user.uid && userHasBilling === undefined) {
      makePaymentsGet()
    }
  }, [currentUser, makePaymentsGet, userHasBilling])

  if (!userLogged) {
    return (
      <Loading>
        <Spin tip="A Carregar..." size="large" />
      </Loading>
    )
  }

  const getDashContent = () => {
    if (activeMenu === 'examesCacador:1') {
      return (
        <NewTest
          firebaseApp={firebaseApp}
          setActiveMenu={(value?: string) => changedNavigation(value)}
          userHasBilling={userHasBilling}
        />
      )
    } else if (activeMenu === 'examesCacador:2') {
      return (
        <ICNFResults
          firebaseApp={firebaseApp}
          setActiveMenu={(value?: string) => changedNavigation(value)}
        />
      )
    } else if (activeMenu === 'examesLUPA:1') {
      return (
        <NewTestLupa
          firebaseApp={firebaseApp}
          setActiveMenu={(value?: string) => changedNavigation(value)}
          userHasBilling={userHasBilling}
        />
      )
    } else if (activeMenu === 'examesLUPA:2') {
      return (
        <LUPAResults
          firebaseApp={firebaseApp}
          setActiveMenu={(value?: string) => changedNavigation(value)}
        />
      )
    } else if (activeMenu === 'profile') {
      return (
        <Profile
          firebaseApp={firebaseApp}
          setDashMenu={(value?: string) => changedNavigation(value)}
          setUserHasBilling={setUserHasBilling}
        />
      )
    } else if (activeMenu === 'manualLUPA') {
      return (
        <Doc
          docType="lupa"
          changeNavigation={(value?: string) => changedNavigation(value)}
        />
      )
    } else {
      return (
        <>
          <StyledPageHeader
            backIcon={false}
            title="Plataforma SerCaçador"
            subTitle={`Bem vindo ${JSON.parse(userLogged).displayName}`}
          />
          <DashContainer>
            <p>
              O sítio certo para se preparar para o exame de caçador e exame de
              LUPA.
            </p>
            <Row>
              <MenuBox
                onClick={() => checkBillingAndNavigate('examesCacador:1')}
              >
                Novo Teste Exame Caçador
              </MenuBox>
              <MenuBox
                onClick={() => checkBillingAndNavigate('examesCacador:2')}
              >
                Ver Resultados Exame Caçador
              </MenuBox>
            </Row>
            <Row>
              <MenuBox onClick={() => checkBillingAndNavigate('examesLUPA:1')}>
                Novo Teste Uso e Porte de Arma
              </MenuBox>
              <MenuBox onClick={() => checkBillingAndNavigate('examesLUPA:2')}>
                Ver Resultados Uso e Porte de Arma
              </MenuBox>
            </Row>
            <Row>
              <MenuBox onClick={() => checkBillingAndNavigate('manualLUPA')}>
                Consultar Manual Uso e Porte de Arma
              </MenuBox>
            </Row>
          </DashContainer>
        </>
      )
    }
  }

  const checkBillingAndNavigate = (key?: string) => {
    if (!userHasBilling) {
      message.error(
        <span>
          <p>Atenção, Não tem a subscrição do serviço ativa.</p>
          {key === 'examesCacador:1' ||
            (key === 'examesLUPA:1' && <p>Vai ver apenas um teste exemplo</p>)}

          <p>{'Vá até: Minha Conta -> Subscrição para fazer o pagamento'}</p>
          <Button
            type="primary"
            onClick={() => {
              setActiveMenu('profile')
            }}
          >
            Ir Agora
          </Button>
        </span>,
        5
      )
    }

    if (key === 'manualLUPA' && !userHasBilling) {
      return
    }

    setActiveMenu(key)
  }
  const changedNavigation = (key?: string) => setActiveMenu(key)

  return (
    <Container>
      <Navbar changedNavigation={changedNavigation} />
      {getDashContent()}
    </Container>
  )
}

export default Dashboard

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100%;
  background-color: #ececec;
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),
    url(${backgroundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: #fafafa;
`

const Loading = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`
const DashContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 25px;
  width: 100%;
  height: 100%;
  max-height: 100%;

  @media (max-width: 768px) {
    overflow-y: auto;
  }
`
const StyledPageHeader = styled(PageHeader)`
  span {
    color: #fafafa;
  }
`
const MenuBox = styled.div`
  width: 400px;
  height: 100px;
  background-color: #fafafa;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #fafafa;
  border-radius: 5px;
  margin: 10px;
  opacity: 0.8;

  &:hover {
    background-color: lightblue;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 10px 0;
  }
`
const Row = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`
